module.exports = __webpack_public_path__ + "img/maximize.56620ca3.svg";